
import React from 'react'
// hooks
import DefaultAvatar from '@mui/material/Avatar'
import useAuth from '../hooks/useAuth'
// utils
import createAvatar from '../utils/createAvatar'
//
import Avatar, { Props as AvatarProps } from './Avatar'

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: AvatarProps) {
	const { user } = useAuth()
	if (!user?.isDisplayNameSet) {
		return (
			<DefaultAvatar alt="Yo" />
		)
	}

	return (
		<Avatar
			src={user?.photoURL}
			alt={user?.displayName}
			color={user?.photoURL ? 'default' : createAvatar(user?.displayName).color}
			{...other}
		>
			{createAvatar(user?.displayName).name}
		</Avatar>
	)
}
